<template>
    <div class="right-fixed">
        <ul>
            <li><a href="#first-floor">好店推荐</a></li>
            <li><a href="#second-floor">活动说明</a></li>
            <li><a href="#third-floor">参考话题</a></li>
            <li><a href="#fourth-floor">精选作品</a></li>
            <li class="code"><img src="https://media6.imgyb.xyz/media/v1/image/57fd427847ffbdf0e3077df6cab3ed9e.png" alt=""></li>
            <li class="join-note">马上加入活动专属群</li>

        </ul>
        
        <img src="https://media4.imgyb.xyz/media/v1/image/345a99089397ebe907e30fe70682b8d8.png" alt="">
    </div>
</template>
<script>
export default {
    name:'RightFixed',
    data(){
        return {

        }
    }
}
</script>
<style lang="less" scoped>
.right-fixed{
    position: fixed; z-index: 15; left: 50%; bottom: 100px; margin-left: 545px;
    *{box-sizing: border-box;}
    ul{
        background: #08B0F5; padding: 15px 0 10px; margin: 0 1px 0 3px; border-radius: 8px 8px 0 0;
        li{
            text-align: center;
            a{font-size: 16px; line-height: 36px; color: #fff;}
            &:hover{text-decoration: underline;}
            &.code{
                width:110px; height: 110px; padding: 5px; background: #fff; border-radius: 4px; margin: 5px auto;
                img{width:100px}
            } 
            &.join-note{ font-size: 13px; color: #fff; line-height: 18px; font-weight: 400;}
        }
    }
}
</style>